/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyDropboxIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-dropbox" */ './utils').then((m) => m.DropboxIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/dropbox/icon' },
);

const LazyDropboxSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-dropbox-search-result" */ './utils').then(
			(m) => m.DropboxSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/dropbox/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const DropboxIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyDropboxIconComponent />
	</Suspense>
);

export const DropboxSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyDropboxSearchResultIconComponent />
	</Suspense>
);
